import { useEffect, useLayoutEffect, useState } from "react";
import { Outlet,  useNavigate } from "react-router-dom";

import { loadUser } from "../../store/features/Auth/AuthApi";
import { RootStore, useAppDispatch, useAppSelector } from "../../store/store";
import { roles } from "../../helpers/utils/Constants/roles";
import { hasAnyFreeRole, isSelfPacedRole } from "../../helpers/utils/roleUtils";

/* eslint-disable no-else-return */
const SelfPacedUserRoute = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(false);
  const [authFail, setAuthFail] = useState(false);

  const dispatch = useAppDispatch();
  const authState: any = useAppSelector((store: RootStore) => {
    return store.AuthSlice;
  });

  useLayoutEffect(() => {
    dispatch(loadUser({ setAuthFail: setAuthFail }));
  }, []);
  useEffect(() => {
    if (authFail) {
      navigate("/");
    }
  }, [authFail]);

  useLayoutEffect(() => {
    if (authState.authenticated && authState.tac_user) {
      if (
        (isSelfPacedRole(authState?.tac_user?.role,authState)|| hasAnyFreeRole(authState?.tac_user?.all_roles))
      ) {
        setUser(true);
      }
    }
  }, [authState.authenticated]);

  useEffect(() => {
    if (authState.authenticated && authState.tac_user) {
      if (!authState.tac_user.default_password_updated) {
        navigate("/default-password-change");
      }
    }
  }, [authState.authenticated]);

  if (user) {
    return <Outlet />;
  } else {
    return null;
  }
};

export default SelfPacedUserRoute;
